<script lang="ts" setup>
import Button from 'primevue/button'
import FormDropdown from '@/components/inputs/FormDropdown.vue'
import FormInputText from '@/components/inputs/FormInputText.vue'
import { ref, onMounted, computed } from 'vue'
import { Icon } from '@iconify/vue'
import { locationData} from '@/constants/customers'
import {formatAddress, addressTypeData} from '@/constants/index'

const props = defineProps<{
  formPath: string
  type: 'add' | 'edit' | 'view'
  addressValues: any
  showRemoveButton: boolean
  expandedAddressView: boolean
  validateAddress: () => boolean
  removeAddress: () => void
}>()

const isAddressExpanded = ref(props.expandedAddressView)
const formattedAddress = computed(() => {
  return formatAddress(props.addressValues)
})

const saveAddress = () => {
  if (props.validateAddress()) isAddressExpanded.value = false
}

onMounted(async () => {
})
</script>

<template>
  <div
    class="col-span-2 grid grid-cols-1 md:grid-cols-2 gap-y-6 gap-x-10"
    v-show="isAddressExpanded"
  >
    <FormDropdown
      label="Address Type"
      :inputName="`${formPath}.addressType`"
      id="addressType"
      :options="addressTypeData"
      optionLabel="name"
    />
    <FormInputText :model-value="addressValues?.line1" label="Address 1" :inputName="`${formPath}.line1`" id="address1" />
    <FormInputText :model-value="addressValues?.line2" label="Address 2" :inputName="`${formPath}.line2`" id="address2" />
    <FormInputText :model-value="addressValues?.city" label="City" :inputName="`${formPath}.city`" id="city" />
    <FormInputText :model-value="addressValues?.region" label="Region" :inputName="`${formPath}.region`" id="region" />
    <FormInputText :model-value="addressValues?.postCode" label="Postcode" :inputName="`${formPath}.postCode`" id="postcode" />
    <FormInputText :model-value="addressValues?.country" label="Country" :inputName="`${formPath}.country`" id="country" />
    <FormDropdown
      label="Location"
      :inputName="`${formPath}.location`"
      id="location"
      :options="locationData"
      optionLabel="name"
    />

    <div class="flex items-center justify-end gap-x-3 col-span-2">
      <Button
        v-ripple
        class="gap-x-2"
        severity="danger"
        type="button"
        @click="removeAddress"
        v-show="showRemoveButton"
      >
        <span> Remove </span>
        <span><Icon icon="ic:baseline-minus" class="text-xl" /></span>
      </Button>
      <Button v-ripple class="gap-x-2" type="button" @click="saveAddress" :disabled="formattedAddress.length === 0">
        <span> Add This Address </span>
        <Icon icon="material-symbols:save" class="text-xl" />
      </Button>
    </div>
  </div>

  <div
    v-show="!isAddressExpanded"
    class="bg-neutral-50 border rounded-lg border-dashed border-neutral-200 p-3 col-span-2 flex items-center justify-between"
  >
  <p class="font-medium italic text-sm" >
      {{ formattedAddress }}
    </p>

    <div class="flex items-center gap-x-3" v-if="type !== 'view'">
      <Button
        type="button"
        class="!p-1"
        title="Edit Address"
        rounded
        @click="isAddressExpanded = true"
      >
        <Icon icon="ic:baseline-edit" class="text-xl" />
      </Button>

      <Button
        v-show="showRemoveButton"
        type="button"
        class="!p-1"
        severity="danger"
        title="Remove Address"
        rounded
        @click="removeAddress"
      >
        <Icon icon="ic:baseline-minus" class="text-xl" />
      </Button>
    </div>
  </div>
</template>

<style></style>
